import moment from 'moment';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useApplicationContext } from '@/context/v1/Application/context';
import { useCreateActionPlanTask } from '@/hooks/v2/useCreateActionPlanTask';
import type { Task } from '@/components/ActionPlan/types';

const { useFormInstance, useWatch } = Form;

export function useTasks(actionPlanId?: string) {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();
	const { mutateAsync: createTask } = useCreateActionPlanTask();

	const taskList: Task[] = useWatch('task_list', form) || [];
	const percentProgress = taskList.filter((task) => task.is_completed).length;

	async function handleOnAddTask(data: Task): Promise<void> {
		if (actionPlanId) {
			const payload = {
				action_plan_id: actionPlanId,
				organization_id: organization.id!,
				company_id: company.id!,
				due_date: data.due_date ? moment(data.due_date).toDate() : undefined,
				responsible_user_id: data.responsible_user_id,
				title: data.title
			};

			await createTask(payload);
		} else {
			const newTask = {
				title: data.title,
				is_completed: false,
				due_date: data.due_date,
				responsible_user_id: data.responsible_user_id
			};

			form.setFieldValue('task_list', [...taskList, newTask]);
		}
	}

	const descriptionTasks: string = I18n.get(
		'Each task corresponds to a specific administrative or engineering measure. Modify the person responsible and the due date, and keep the “Administrative” or “Engineering” prefix when modifying the task name. To create new tasks, always identify them with the corresponding measure prefix in the title.'
	);

	return {
		form,
		taskList,
		percentProgress,
		descriptionTasks,
		handleOnAddTask
	};
}
